import classNames from 'classnames'

const ThickDivider = ({ screenFull = true, mx = 20 }) => {
  return (
    <div
      className={classNames(
        `mx-[20px] h-[1px] flex-1 bg-gray-200`,
        screenFull && `mx-[-20px]`,
        !screenFull && `mx-[0px]`
      )}
    />
  )
}

export default ThickDivider
